import { render, staticRenderFns } from "./LandlordPropertiesView.vue?vue&type=template&id=215ee22a&scoped=true&"
import script from "./LandlordPropertiesView.vue?vue&type=script&lang=js&"
export * from "./LandlordPropertiesView.vue?vue&type=script&lang=js&"
import style0 from "./LandlordPropertiesView.vue?vue&type=style&index=0&id=215ee22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ee22a",
  null
  
)

export default component.exports